<template>
  <div class="header" :class="nowLang">
    <div class="header-content">
      <AccountBox ></AccountBox>
      <LangSelect v-if="langList.length && langList.length > 1"></LangSelect>
    </div>
    <progress-bar v-if="isAnswering"></progress-bar>
  </div>
</template>

<script lang="ts" setup>
import LangSelect from "@/components/header/LangSelect.vue";
import AccountBox from "@/components/header/AccountBox.vue";
import langHook from "@/hooks/langHook.ts";
import ProgressBar from "@/components/common/Progress.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";

const route = useRoute();
const isAnswering = computed(() => route.name === "question");
const { langList, nowLang } = langHook();
</script>
<style lang="scss" scoped>
@import "@/assets/scss/dimen.scss";
.header {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  background: linear-gradient(to bottom, #dae7ff, #fff);
  height: 100px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 2px 15px #ccc;
  @media (orientation: landscape) {
    height: 90px;
    padding: 0 30px;
  }
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
